import Detail from "./Detail";

const NewDetail = () => {
  return (
    <div>
      <div className="container">
        <Detail />
      </div>
    </div>
  );
};

export default NewDetail;
